import { Label } from "expano-components";
import { Button, MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const BrandList = ({ history }) => (
  <Main
    page={{
      name: "Marki",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Marki",
        },
      ],
      buttons: <Button type="add" text="Dodaj markę" path="/brands/new" />,
    }}
  >
    <MainList
      query_key="brands"
      api_path="/brands"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/brands/${item.id}`)}
      renderItem={({ name, email, producer, channels }) => (
        <>
          <td>{name}</td>
          <td>{email || "-"}</td>
          <td>{producer?.name}</td>
          <td>
            <div style={{ display: "flex", gap: "13px 0", flexFlow: "wrap" }}>
              {channels
                ?.sort((a, b) => a.id - b.id)
                ?.map(({ id, shop, platform }) => (
                  <span key={id} style={{ whiteSpace: "nowrap" }}>
                    <Label
                      type="double"
                      left={{
                        text: shop?.label_text,
                        color: `#${shop?.label_color}`,
                      }}
                      right={{
                        text: platform?.label_text,
                        color: `#${platform?.label_color}`,
                      }}
                    />
                  </span>
                ))}
            </div>
          </td>
        </>
      )}
    />
  </Main>
);

export default BrandList;
